import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedPosts = ({ posts }) => {
  if (!posts?.length) return null;

  const [primary, secondary] = posts;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr)?.toLocaleDateString('nb-NO', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <section style={{ padding: '80px 6%', background: '#050A12', position: 'relative' }}>
      {/* Section header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '48px' }}>
        <div style={{ width: '6px', height: '48px', background: '#3B6FD4' }} />
        <div>
          <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.7rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.25em', textTransform: 'uppercase', margin: 0 }}>Utvalgte artikler</p>
          <h2 style={{ fontFamily: 'Impact, sans-serif', fontSize: 'clamp(1.8rem, 4vw, 3rem)', fontWeight: 900, color: '#EEF0F2', margin: 0, textTransform: 'uppercase', letterSpacing: '-0.02em' }}>FREMHEVEDE SAKER</h2>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', maxWidth: '1400px' }}>
        {/* Primary featured post */}
        {primary && (
          <Link
            to={`/individual-article-detail-view?slug=${primary?.slug}`}
            style={{ textDecoration: 'none', display: 'block' }}
          >
            <div
              style={{
                position: 'relative',
                background: '#0D1520',
                border: '1px solid rgba(59,111,212,0.2)',
                overflow: 'hidden',
                transform: 'rotate(-0.5deg)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'rotate(0deg) translateY(-4px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(59,111,212,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'rotate(-0.5deg)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              {/* Polaroid image */}
              <div style={{ position: 'relative', height: '320px', overflow: 'hidden' }}>
                <img
                  src={primary?.hero_image || 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800&h=400&fit=crop'}
                  alt={primary?.hero_image_alt || primary?.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(5,10,18,0.9) 0%, transparent 60%)' }} />
                {/* Category badge */}
                <div style={{ position: 'absolute', top: '16px', left: '16px', background: '#3B6FD4', padding: '4px 12px', fontFamily: 'Syne, sans-serif', fontSize: '0.65rem', fontWeight: 700, color: '#EEF0F2', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
                  {primary?.category}
                </div>
                {/* Featured star */}
                <div style={{ position: 'absolute', top: '16px', right: '16px', background: '#F5A623', padding: '4px 10px', fontFamily: 'Syne, sans-serif', fontSize: '0.6rem', fontWeight: 700, color: '#050A12', letterSpacing: '0.1em', textTransform: 'uppercase', transform: 'rotate(2deg)' }}>
                  ★ Fremhevet
                </div>
              </div>

              {/* Content */}
              <div style={{ padding: '24px' }}>
                <h3
                  style={{
                    fontFamily: 'Syne, sans-serif',
                    fontSize: 'clamp(1.1rem, 2vw, 1.5rem)',
                    fontWeight: 800,
                    color: '#EEF0F2',
                    margin: '0 0 12px',
                    lineHeight: 1.2,
                    letterSpacing: '-0.02em'
                  }}
                >
                  {primary?.title}
                </h3>
                <p style={{ fontFamily: 'Georgia, serif', fontSize: '0.9rem', color: 'rgba(238,240,242,0.65)', lineHeight: 1.7, margin: '0 0 20px' }}>
                  {primary?.excerpt}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {primary?.author_avatar && (
                      <img src={primary?.author_avatar} alt={`Portrett av ${primary?.author_name}`} style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(59,111,212,0.4)' }} />
                    )}
                    <div>
                      <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#EEF0F2', margin: 0 }}>{primary?.author_name}</p>
                      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.7rem', color: 'rgba(238,240,242,0.45)', margin: 0 }}>{formatDate(primary?.published_at)}</p>
                    </div>
                  </div>
                  <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Les mer →</span>
                </div>
              </div>
            </div>
          </Link>
        )}

        {/* Secondary featured post */}
        {secondary && (
          <Link
            to={`/individual-article-detail-view?slug=${secondary?.slug}`}
            style={{ textDecoration: 'none', display: 'block' }}
          >
            <div
              style={{
                position: 'relative',
                background: '#0D1520',
                border: '1px solid rgba(59,111,212,0.2)',
                overflow: 'hidden',
                transform: 'rotate(0.5deg)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'rotate(0deg) translateY(-4px)'; e.currentTarget.style.boxShadow = '0 20px 60px rgba(59,111,212,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'rotate(0.5deg)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div style={{ position: 'relative', height: '320px', overflow: 'hidden' }}>
                <img
                  src={secondary?.hero_image || 'https://images.unsplash.com/photo-1551524559-8af4e6624178?w=800&h=400&fit=crop'}
                  alt={secondary?.hero_image_alt || secondary?.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(5,10,18,0.9) 0%, transparent 60%)' }} />
                <div style={{ position: 'absolute', top: '16px', left: '16px', background: '#3B6FD4', padding: '4px 12px', fontFamily: 'Syne, sans-serif', fontSize: '0.65rem', fontWeight: 700, color: '#EEF0F2', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
                  {secondary?.category}
                </div>
                <div style={{ position: 'absolute', top: '16px', right: '16px', background: '#F5A623', padding: '4px 10px', fontFamily: 'Syne, sans-serif', fontSize: '0.6rem', fontWeight: 700, color: '#050A12', letterSpacing: '0.1em', textTransform: 'uppercase', transform: 'rotate(-2deg)' }}>
                  ★ Fremhevet
                </div>
              </div>
              <div style={{ padding: '24px' }}>
                <h3 style={{ fontFamily: 'Syne, sans-serif', fontSize: 'clamp(1.1rem, 2vw, 1.5rem)', fontWeight: 800, color: '#EEF0F2', margin: '0 0 12px', lineHeight: 1.2, letterSpacing: '-0.02em' }}>
                  {secondary?.title}
                </h3>
                <p style={{ fontFamily: 'Georgia, serif', fontSize: '0.9rem', color: 'rgba(238,240,242,0.65)', lineHeight: 1.7, margin: '0 0 20px' }}>
                  {secondary?.excerpt}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {secondary?.author_avatar && (
                      <img src={secondary?.author_avatar} alt={`Portrett av ${secondary?.author_name}`} style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(59,111,212,0.4)' }} />
                    )}
                    <div>
                      <p style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#EEF0F2', margin: 0 }}>{secondary?.author_name}</p>
                      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.7rem', color: 'rgba(238,240,242,0.45)', margin: 0 }}>{formatDate(secondary?.published_at)}</p>
                    </div>
                  </div>
                  <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Les mer →</span>
                </div>
              </div>
            </div>
          </Link>
        )}
      </div>
    </section>
  );
};

export default FeaturedPosts;
